import { Navigate, RouteObject } from 'react-router-dom';
import { HasAccess } from '../../features/has-access/has-access';
import { MobileNotifications } from '../../features/notifications/mobile-notifications/mobile-notifications';
import { MobileNotificationsAll } from '../../features/notifications/mobile-notifications/mobile-notifications-all/mobile-notifications-all';
import { MobileNotificationsReviews } from '../../features/notifications/mobile-notifications/mobile-notifications-reviews/mobile-notifications-reviews';
import { MobileNotificationsStaff } from '../../features/notifications/mobile-notifications/mobile-notifications-staff/mobile-notifications-staff';
import { Login } from '../../pages/manager/auth/login/login';
import { Restore } from '../../pages/manager/auth/restore/restore';
import { AppSettings } from '../../pages/manager/body/cabinet/app-settings/app-settings';
import { Branches } from '../../pages/manager/body/cabinet/branches/branches';
import { CompanySettings } from '../../pages/manager/body/cabinet/company-settings/company-settings';
import { Profile } from '../../pages/manager/body/cabinet/profile/profile';
import { ProfilePersonal } from '../../pages/manager/body/cabinet/profile/profile-tabs/profile-personal/profile-personal';
import { ProfileSecurity } from '../../pages/manager/body/cabinet/profile/profile-tabs/profile-security/profile-security';
import { ProfileSettings } from '../../pages/manager/body/cabinet/profile/profile-tabs/profile-settings/profile-settings';
import { ProfileSocials } from '../../pages/manager/body/cabinet/profile/profile-tabs/profile-socials/profile-socials';
import { RolesAndAccess } from '../../pages/manager/body/cabinet/roles-and-access/roles-and-access';
import { DashboardMenu } from '../../pages/manager/body/dashboard/dashboard-menu/dashboard-menu';
import { DashboardQr } from '../../pages/manager/body/dashboard/dashboard-qr/dashboard-qr';
import { DashboardReviews } from '../../pages/manager/body/dashboard/dashboard-reviews/dashboard-reviews';
import { DashboardStaff } from '../../pages/manager/body/dashboard/dashboard-staff/dashboard-staff';
import { DashboardTasks } from '../../pages/manager/body/dashboard/dashboard-tasks/dashboard-tasks';
import { DashboardExternalMonitoring } from '../../pages/manager/body/dashboard/dashboard-external-monitoring/dashboard-external-monitoring.tsx';
import { CreateDeviceQr } from '../../pages/manager/body/devices/create-device-qr/create-device-qr';
import { DeviceQrList } from '../../pages/manager/body/devices/device-qr-list/device-qr-list';
import { CreateForm } from '../../pages/manager/body/forms/forms-create/forms-create';
import { FormsList } from '../../pages/manager/body/forms/forms-list';
import { Config } from '../../pages/manager/body/leads/config/config';
import { ListLeads } from '../../pages/manager/body/leads/list/list-leads';
import { MenuIiko } from '../../pages/manager/body/menu/menu-iiko/menu-iiko';
import { MenuInformer } from '../../pages/manager/body/menu/menu-informer/menu-informer';
import { MenuInformerImport } from '../../pages/manager/body/menu/menu-informer/menu-informer-import/menu-informer-import';
// import { MonitoringDashboard } from '../../pages/manager/body/monitoring/monitoring-dashboard/monitoring-dashboard';
// import { MonitoringMentions } from '../../pages/manager/body/monitoring/monitoring-mentions/monitoring-mentions';
// import { MonitoringSettings } from '../../pages/manager/body/monitoring/monitoring-settings/monitoring-settings';
import { ReviewSources } from '../../pages/manager/body/monitoring-scope/review-sources/table/review-sources-table';
import { ExternalReviewsTable } from '../../pages/manager/body/monitoring-scope/external-reviews/table/external-reviews-table';
import { CreatePromo } from '../../pages/manager/body/promotions/create-promo/create-promo';
import { PromoList } from '../../pages/manager/body/promotions/promo-list';
import { CreateQr } from '../../pages/manager/body/qrs/create/create-qr';
import { QrList } from '../../pages/manager/body/qrs/list/qr-list';
import { Reviews } from '../../pages/manager/body/reviews/reviews';
import { CheckInCheckOut } from '../../pages/manager/body/staff/check-in-check-out/check-in-check-out';
import { EmployeeProfile } from '../../pages/manager/body/staff/employee-profile/employee-profile';
import { Employees } from '../../pages/manager/body/staff/employees/employees';
import { RolesDictionary } from '../../pages/manager/body/staff/roles-dictionary/roles-dictionary';
import { ShiftsImport } from '../../pages/manager/body/staff/shifts-import/shifts-import';
import { Shifts } from '../../pages/manager/body/staff/shifts/shifts';
import { Statements } from '../../pages/manager/body/staff/statements/statements';
import { TasksPlanner } from '../../pages/manager/body/tasks-planner/tasks-planner';
import { TaskList } from '../../pages/manager/body/tasks/task-list';
import { CreateTree } from '../../pages/manager/body/trees/create-tree/create-tree';
import { TreeList } from '../../pages/manager/body/trees/tree-list';
import {
  AuthPath,
  CabinetPath,
  DashboardPath,
  DevicesPath,
  FormPath,
  InformerPath,
  LeadesPath as LeadsPath,
  ManagerPath,
  MenuPath,
  // MonitoringPath,
  NotificationsPath,
  ProfilePath,
  PromotionPath,
  QrCodesPath,
  ReviewsPath,
  StaffPath,
  TasksPath,
  TreesPath,
  MonitoringScopePath
} from './manager-enums';

export const authPaths: RouteObject[] = [
  {
    path: AuthPath.Login,
    element: <Login />,
  },
  {
    path: AuthPath.Restore,
    element: <Restore />,
  },
];

export const managerPaths: RouteObject[] = [
  {
    element: (
      <HasAccess service="profile" permissions={['read', 'write']}>
        <Profile />
      </HasAccess>
    ),
    children: [
      {
        index: true,
        element: (
          <HasAccess service="profile" permissions={['read', 'write']}>
            <Navigate to={ProfilePath.Personal} replace />,
          </HasAccess>
        ),
      },
      {
        path: ProfilePath.Personal,
        element: (
          <HasAccess service="profile" permissions={['read', 'write']}>
            <ProfilePersonal />
          </HasAccess>
        ),
      },
      {
        path: ProfilePath.Security,
        element: (
          <HasAccess service="profile" permissions={['read', 'write']}>
            <ProfileSecurity />
          </HasAccess>
        ),
      },
      {
        path: ProfilePath.Socials,
        element: (
          <HasAccess service="profile" permissions={['read', 'write']}>
            <ProfileSocials />
          </HasAccess>
        ),
      },
      {
        path: ProfilePath.Settings,
        element: (
          <HasAccess service="profile" permissions={['read', 'write']}>
            <ProfileSettings />
          </HasAccess>
        ),
      },
    ],
  },
  {
    path: ManagerPath.Cabinet,
    children: [
      {
        path: CabinetPath.CompanySettings,
        element: <CompanySettings />,
      },
      {
        path: CabinetPath.Branches,
        element: <Branches />,
      },
      {
        path: CabinetPath.App,
        element: <AppSettings />,
      },
      {
        path: CabinetPath.RolesAndAccess,
        element: <RolesAndAccess />,
      },
    ],
  },
  {
    path: ManagerPath.Dashboard,
    children: [
      {
        path: DashboardPath.Menu,
        element: <DashboardMenu />,
      },
      {
        path: DashboardPath.Tasks,
        element: <DashboardTasks />,
      },
      {
        path: DashboardPath.Reviews,
        element: <DashboardReviews />,
      },
      {
        path: DashboardPath.Staff,
        element: <DashboardStaff />,
      },
      {
        path: DashboardPath.Qr,
        element: <DashboardQr />,
      },
      {
        path: DashboardPath.ExternalMonitoring,
        element: <DashboardExternalMonitoring />,
      },
    ],
  },
  {
    path: ManagerPath.QrCodes,
    children: [
      {
        path: QrCodesPath.CreateStatic,
        element: (
          <HasAccess service="qr" permissions={['write']}>
            <CreateQr />
          </HasAccess>
        ),
      },
      {
        path: QrCodesPath.EditStatic,
        element: (
          <HasAccess service="qr" permissions={['write']}>
            <CreateQr />
          </HasAccess>
        ),
      },
      {
        path: QrCodesPath.StaticList,
        element: (
          <HasAccess service="qr" permissions={['read', 'write']}>
            <QrList />
          </HasAccess>
        ),
      },
    ],
  },
  {
    path: ManagerPath.Reviews,
    children: [
      {
        path: ReviewsPath.Branch,
        element: (
          <HasAccess service="review" permissions={['read', 'write']}>
            <Reviews />
          </HasAccess>
        ),
      },
      {
        path: ReviewsPath.Order,
        element: (
          <HasAccess service="review" permissions={['read', 'write']}>
            <Reviews />
          </HasAccess>
        ),
      },
      {
        path: ReviewsPath.Action,
        element: (
          <HasAccess service="review" permissions={['read', 'write']}>
            <Reviews />
          </HasAccess>
        ),
      },
    ],
  },
  {
    path: ManagerPath.Trees,
    children: [
      {
        path: TreesPath.CreateTree,
        element: (
          <HasAccess service="tree" permissions={['write']}>
            <CreateTree />
          </HasAccess>
        ),
      },
      {
        path: TreesPath.EditTree,
        element: (
          <HasAccess service="tree" permissions={['write']}>
            <CreateTree />
          </HasAccess>
        ),
      },
      {
        path: TreesPath.ListTree,
        element: (
          <HasAccess service="tree" permissions={['read', 'write']}>
            <TreeList />
          </HasAccess>
        ),
      },
    ],
  },
  {
    path: ManagerPath.Tasks,
    children: [
      {
        path: TasksPath.Order,
        element: <TaskList />,
      },
      {
        path: TasksPath.Action,
        element: <TaskList />,
      },
      {
        path: TasksPath.Common,
        element: <TaskList />,
      },
      {
        path: TasksPath.Planner,
        element: (
          <HasAccess service="task" permissions={['read', 'write']}>
            <TasksPlanner />
          </HasAccess>
        ),
      },
    ],
  },
  {
    path: ManagerPath.Staff,
    children: [
      {
        path: StaffPath.Employees,
        element: (
          <HasAccess service="staff" permissions={['read', 'write']}>
            <Employees />
          </HasAccess>
        ),
      },
      {
        path: StaffPath.EmployeeProfile,
        element: (
          <HasAccess service="staff" permissions={['read', 'write']}>
            <EmployeeProfile />
          </HasAccess>
        ),
      },
      {
        path: StaffPath.CheckInCheckOut,
        element: (
          <HasAccess service="staff" permissions={['read', 'write']}>
            <CheckInCheckOut />
          </HasAccess>
        ),
      },
      {
        path: StaffPath.Shifts,
        element: (
          <HasAccess service="staff" permissions={['read', 'write']}>
            <Shifts />
          </HasAccess>
        ),
      },
      {
        path: StaffPath.ShiftsImport,
        element: (
          <HasAccess service="staff" permissions={['write']}>
            <ShiftsImport />
          </HasAccess>
        ),
      },
      {
        path: StaffPath.Statements,
        element: (
          <HasAccess service="staff" permissions={['read', 'write']}>
            <Statements />
          </HasAccess>
        ),
      },
      {
        path: StaffPath.RolesDictionary,
        element: (
          <HasAccess service="staff" permissions={['read', 'write']}>
            <RolesDictionary />
          </HasAccess>
        ),
      },
    ],
  },
  {
    path: ManagerPath.Monitoring,
    children: [
      {
        path: MonitoringScopePath.ReviewSources,
        element: (
          <HasAccess service="monitoring" permissions={['read', 'write']}>
            <ReviewSources />
          </HasAccess>
        ),
      },
      {
        path: MonitoringScopePath.ExternalReviews,
        element: (
          <HasAccess service="monitoring" permissions={['read', 'write']}>
            <ExternalReviewsTable />
          </HasAccess>
        ),
      },
    ],
  },
  {
    path: ManagerPath.Menu,
    children: [
      {
        path: MenuPath.Informer,
        children: [
          {
            path: InformerPath.List,
            element: (
              <HasAccess service="menu" permissions={['read', 'write']}>
                <MenuInformer />
              </HasAccess>
            ),
          },
          {
            path: InformerPath.Import,
            element: (
              <HasAccess service="menu" permissions={['write']}>
                <MenuInformerImport />
              </HasAccess>
            ),
          },
        ],
      },
      {
        path: MenuPath.Iiko,
        element: (
          <HasAccess service="menu" permissions={['read', 'write']}>
            <MenuIiko />
          </HasAccess>
        ),
      },
    ],
  },
  {
    path: ManagerPath.Lead,
    children: [
      {
        path: LeadsPath.List,
        element: (
          <HasAccess service="lead" permissions={['read', 'write']}>
            <ListLeads />
          </HasAccess>
        ),
      },
      {
        path: LeadsPath.Config,
        element: (
          <HasAccess service="lead" permissions={['write']}>
            <Config />
          </HasAccess>
        ),
      },
    ],
  },
  {
    path: ManagerPath.Promotion,
    children: [
      {
        path: PromotionPath.List,
        element: (
          <HasAccess service="promotion" permissions={['read', 'write']}>
            <PromoList />
          </HasAccess>
        ),
      },
      {
        path: PromotionPath.Create,
        element: (
          <HasAccess service="promotion" permissions={['write']}>
            <CreatePromo />
          </HasAccess>
        ),
      },
      {
        path: PromotionPath.Edit,
        element: (
          <HasAccess service="promotion" permissions={['write']}>
            <CreatePromo />
          </HasAccess>
        ),
      },
    ],
  },
  {
    path: ManagerPath.Form,
    children: [
      {
        path: FormPath.Create,
        element: (
          <HasAccess service="form" permissions={['write']}>
            <CreateForm />
          </HasAccess>
        ),
      },
      {
        path: FormPath.List,
        element: (
          <HasAccess service="form" permissions={['read', 'write']}>
            <FormsList />
          </HasAccess>
        ),
      },
    ],
  },
  {
    path: ManagerPath.Devices,
    children: [
      {
        path: DevicesPath.Create,
        element: (
          <HasAccess service="device" permissions={['write']}>
            <CreateDeviceQr />
          </HasAccess>
        ),
      },
      {
        path: DevicesPath.Edit,
        element: (
          <HasAccess service="device" permissions={['write']}>
            <CreateDeviceQr />
          </HasAccess>
        ),
      },
      {
        path: DevicesPath.List,
        element: (
          <HasAccess service="device" permissions={['read', 'write']}>
            <DeviceQrList />
          </HasAccess>
        ),
      },
    ],
  },
  {
    path: ManagerPath.Notifications,
    element: <MobileNotifications />,
    children: [
      {
        path: NotificationsPath.All,
        element: <MobileNotificationsAll />,
      },
      {
        path: NotificationsPath.Reviews,
        element: <MobileNotificationsReviews />,
      },
      {
        path: NotificationsPath.Staff,
        element: <MobileNotificationsStaff />,
      },
    ],
  },
];
